import Body from './body';
import Button from './button';
import CloseButton from './close-button';
import Footer from './footer';
import Header from './header';
import ModalInternal from './modal-internal';
const ModalNamespace = Object.assign(ModalInternal, {
    Body,
    Button,
    CloseButton,
    Footer,
    Header,
});
export default ModalNamespace;
